<template>
  <section class="listagem-principal">
    <!-- BARRA DE TITULO -->
    <div class="barra-de-titulo">
      <h1>{{ titulo }}</h1>
      <span></span>
      <div class="ordenar" v-if="lista.length > 0">
        <h6>Ordenar por:</h6>
        <div>
          <button type="button" @click="handleOrderByName('asc')">
            <img src="@/assets/vivo-consulta/icones/icone-ordem-texto-menor.svg" />
            <label>Ordem Crescente</label>
          </button>
          <button type="button" @click="handleOrderByName('desc')">
            <img src="@/assets/vivo-consulta/icones/icone-ordem-texto-maior.svg" />
            <label>Ordem Decrescente</label>
          </button>
          <button type="button" @click="handleOrderByPrice('asc')">
            <img src="@/assets/vivo-consulta/icones/icone-ordem-valor-menor.svg" />
            <label>Mais Baratos</label>
          </button>
          <button type="button" @click="handleOrderByPrice('desc')">
            <img src="@/assets/vivo-consulta/icones/icone-ordem-valor-maior.svg" />
            <label>Mais Caros</label>
          </button>
        </div>
      </div>
    </div>

    <!-- CONTEUDO -->
    <div class="conteudo">
      <!-- FILTROS LATERAIS -->
      <div class="filtro" v-if="filtros">
        <div class="filtros" v-for="(filtro, index) in filtros" :key="index">
          <a href="javascript:void(0)" @click="filtro.escondido = !filtro.escondido">
            <h5>{{ filtro.titulo }}</h5>
          </a>
          <ul v-if="filtro.escondido">
            <template v-if="filtro.tipo === 'opcao'">
              <li v-for="(parametro, indice) in filtro.parametros" :key="indice">
                <button @click="adicionarFiltro(filtro.nome + '_' + parametro)">
                  <div
                    v-if="filtrosSelecionados.includes(filtro.nome + '_' + parametro)"
                    class="checado"
                  ></div>
                  <div v-else></div>
                  <p>{{ parametro }}</p>
                </button>
              </li>
            </template>
            <template v-if="filtro.tipo === 'input-min-max'">
              <div class="linha-inputs">
                <div>
                  <label>Mín</label>
                  <input v-model.lazy="valormin_faixadevalor" v-money="money" />
                </div>
                <div>
                  <label>Máx</label>
                  <input v-model.lazy="valormax_faixadevalor" v-money="money" />
                </div>
              </div>
            </template>
          </ul>
        </div>
        <div class="acoes">
          <button class="cta" @click="metodoPesquisaPorFiltros">Filtrar</button>
          <button class="discret" @click="resetFiltros">Limpar</button>
        </div>
      </div>

      <!-- LISTAGEM DE ITENS -->
      <div class="lista">
        <template v-if="loading">
          <div class="wrapper-loading">
            <img src="@/assets/vivo-consulta/imagens/spinner.svg" alt="Carregando...." />
          </div>
        </template>
        <template v-else>
          <router-link
            v-for="item in lista"
            :to="{ name: 'vivo.consulta.page', params: { page: 'smartphone', id: item.cel.id } }"
            :class="filtros ? 'com-filtro' : 'sem-filtro'"
            :key="item.id"
            @click="handleEvent('destaque', item.cel.modelo)"
          >
            <div class="foto">
              <img v-if="item.cel.imagem" :src="item.cel.imagem" />
              <img v-else :src="require(`@/assets/vivo-consulta/imagens/zz_mockuphone3.png`)" />
            </div>
            <div class="informacoes">
              <h3>
                {{ item.cel.marca.nome }}
                <br />
                <strong>{{ item.cel.modelo }}</strong>
              </h3>
              <p>
                R$
                <strong>{{ item.cel.preco | convertMoeda }}</strong>
                <sup class="marcacao-pix">*</sup>
              </p>
            </div>
          </router-link>
          <p class="legenda-pix" v-if="lista && lista.length > 0">* À vista no PIX</p>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import EventBus from '@/event-bus';
import { VMoney } from 'v-money';

export default {
  name: 'Listagem',

  props: {
    icone: {
      type: String,
    },
    titulo: {
      type: String,
      required: true,
    },
    filtros: {
      type: Array,
    },
    lista: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  data() {
    return {
      filtrosSelecionados: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: 'false',
      },
      valormin_faixadevalor: undefined,
      valormax_faixadevalor: undefined,
    };
  },

  directives: {
    money: VMoney,
  },

  computed: {
    checkFiltro(filtro) {
      return this.filtrosSelecionados.includes(filtro);
    },
  },

  methods: {
    handleEvent(to, modelo) {
      EventBus.$emit('tb-action', { modelo, action: to });
    },
    handleOrderByName(type) {
      this.$emit('orderBy', {
        order: ['cel.marca.nome', 'cel.modelo'],
        type: [type, type],
      });
    },
    handleOrderByPrice(type) {
      this.$emit('orderBy', { order: ['cel.preco'], type: [type] });
    },
    adicionarFiltro(filtro) {
      if (this.filtrosSelecionados.includes(filtro)) {
        this.filtrosSelecionados.splice(this.filtrosSelecionados.indexOf(filtro), 1);
      } else {
        this.filtrosSelecionados.push(filtro);
      }
    },
    resetFiltros() {
      this.filtrosSelecionados = [];
      this.valormin_faixadevalor = null;
      this.valormax_faixadevalor = null;
    },
    metodoPesquisaPorFiltros() {
      console.log('usar $router para invocar de pesquisa com filtros do this.filtrosSelecionados');
      // usar $router para invocar de pesquisa com filtros do this.filtrosSelecionados
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  -moz-appearance: textfield;
}

.listagem-principal {
  @extend %area-de-utilizacao;
  margin: 15px auto;

  & .barra-de-titulo {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    width: 100%;

    & h1 {
      font-family: 'VivoType';
      font-size: 28px;
      color: $cor_roxo;
      text-transform: uppercase;
      margin: 0px;
      width: fit-content;
      min-width: max-content;
    }

    & span {
      background: $cor_cinza_medium;
      width: 100%;
      margin-left: 20px;
      height: 2px;
    }

    & .ordenar {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      position: absolute;
      top: -15px;
      right: 0;

      & h6 {
        color: $cor_cinza_dark;
        margin: 0 0 4px 0;
      }

      & div {
        display: flex;
        flex-direction: row;
        align-items: center;

        & button {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          outline: none;
          border: 0px;
          background: $cor_roxo;
          border-radius: 5px;
          width: 28px;
          height: 28px;
          margin: 0px;
          padding: 0px;
          margin-left: 5px;
          transition: all 0.2s ease-in-out;

          & img {
            object-fit: contain;
            width: 60%;
            height: 60%;
            margin-right: -2px;
            filter: grayscale(1) brightness(100);
          }

          & label {
            display: none;
            position: absolute;
            top: -30px;
            font-size: 10px;
            padding: 3px 6px;
            border-radius: 5px;
            background: $cor_amarelo;
            color: $cor_roxo;
            font-weight: 600;
            line-height: 1.1em;
            font-family: 'OpenSans';
            box-shadow: 0px 2px 6px rgba(black, 0.25);

            &::before {
              content: ' ';
              background: $cor_amarelo;
              width: 6px;
              height: 6px;
              transform: rotate(45deg);
              position: absolute;
              bottom: -3px;
              left: calc(50% - 3px);
            }
          }

          &:hover {
            background: $cor_amarelo;
            transform: scale(1.25);

            & img {
              filter: none;
            }

            & > label {
              display: block;
            }
          }
        }
      }
    }
  }

  & .conteudo {
    display: flex;
    flex-direction: row;
    padding: 50px 0;

    & .filtro {
      width: 240px;
      margin-right: 40px;

      & .filtros {
        & a {
          text-decoration: none;

          & h5 {
            font-family: 'VivoType';
            font-size: 15px;
            color: $cor_cinza;
            margin: 0px;
            margin-bottom: 3px;
          }
        }

        & ul {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-items: center;
          max-width: 100%;
          margin: 0px;
          margin-bottom: 24px;
          padding: 0px;

          & li {
            font-size: 13px;
            margin: 3px 0;
            padding-right: 18px;

            & button {
              display: flex;
              flex-direction: row;
              align-items: center;
              margin: 0px;
              padding: 0px;
              background: transparent;
              border: 0px;
              outline: none;
              font-family: 'OpenSans';

              & div {
                width: 12px;
                height: 12px;
                border-radius: 3px;
                margin-right: 8px;
                background: $cor_cinza_medium;
                animation: check 0.2s ease-in-out;
                animation-iteration-count: 1;
                transform-style: preserve-3d;
              }

              & .checado {
                background: $cor_roxo;
              }

              & p {
                font-size: 13px;
                color: $cor_cinza;
                margin: 0px;
              }
            }
          }

          & .linha-inputs {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;

            & div {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin: 3px 0;

              & label {
                font-size: 13px;
                color: $cor_cinza;
                margin-right: 3px;
              }

              & input {
                font-family: 'OpenSans';
                padding: 5px;
                margin: 0px;
                width: 72%;
                margin-right: 5px;
                border-radius: 5px;
                color: $cor_cinza;
                font-size: 13px;
                border: 1px solid $cor_cinza_medium;
                outline: none;

                &::placeholder {
                  color: $cor_cinza_medium;
                }

                &:focus {
                  border: 1px solid $cor_cinza;
                }
              }
            }
          }
        }
      }

      & .acoes {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: calc(80% + 25px);

        & button {
          display: flex;
          align-items: center;
          justify-content: center;
          border: none;
          outline: none;
          border-radius: 5px;
          font-family: 'VivoType';
          font-weight: bold;
          font-size: 14px;
          padding: 10px;
          transition: all 0.2s ease-in-out;

          &:hover {
            background: $cor_roxo;
            color: white;
            box-shadow: 0px 7px 20px 1px rgba($cor_roxo, 0.35);
          }
        }

        & .cta {
          flex: 0.8;
          background: $cor_roxo;
          color: white;
          margin-right: 5px;
        }

        & .discret {
          flex: 0.2;
          background: $cor_cinza_medium;
          color: $cor_cinza;
        }
      }
    }

    & .lista {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: flex-start;
      width: 100%;
      height: auto;
      padding: 0;

      & a {
        user-select: none;
        text-decoration: none;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: center;
        margin: 0px;
        margin-bottom: 50px;
        // height: 300px;
        transition: all 0.2s ease-in-out;
        color: $cor_cinza_darkest;

        & .foto {
          display: flex;
          align-items: center;
          justify-content: center;

          & img {
            max-height: 180px;
            object-fit: contain;
            width: auto;
          }
        }

        & .informacoes {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          & h3 {
            font-family: 'OpenSans';
            text-align: center;
            color: $cor_cinza_dark;
            font-weight: 300;
            font-size: 16px;
            margin: 10px 0 0;
            max-width: 90%;
            line-height: 1em;
            text-transform: uppercase;

            & strong {
              font-family: 'VivoType';
            }
          }

          & p {
            color: $cor_cinza_dark;
            font-size: 24px;
            margin: 0px;
            font-weight: 100;

            & strong {
              font-weight: 700;
            }
          }
        }

        &:hover {
          transform: scale(1.05);
          // perspective: 100px;
          // transform: rotateY(360deg);
          // transform-style: preserve-3d
        }

        // &::after {
        //   content: "";
        //   flex: 0 0 380px;
        // }
      }

      & .com-filtro {
        width: 25%;
      }

      & .sem-filtro {
        width: 20%;
      }

      // Ocupa a linha inteira para cair abaixo dos modelos. A margem negativa
      // compensa o margin-bottom de 50px dos cards.
      & .legenda-pix {
        width: 100%;
        margin: -30px 0 0;
        font-size: 12px;
        font-style: italic;
        color: $cor_cinza_dark;
        opacity: 0.85;
      }
    }
  }
}

.wrapper-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 250px;
  & img {
    width: 32px;
    height: 32px;
  }
}

@keyframes check {
  0% {
    transform: rotateY(0deg) rotateX(0deg);
  }
  100% {
    transform: rotateY(180deg) rotateX(180deg);
  }
}

.marcacao-pix {
  font-size: 0.6em;
  line-height: 1;
  margin-left: 2px;
}
</style>
